<template>
  <div v-bind="attrs" class="VZ_TABLE_INPUT">
    <signature-pad
      :modelValue="signatureFile"
      @input="onInput"
      :customStyle="{
        border: 'black 1px solid',
        width: '100% !important',
        minWidth: '130px',
      }"
      saveType="image/svg+xml"
      saveOutput="data_url"
      ref="signaturePad"
      v-if="isPreview"
      :style="style"
      class="col-lg-6 d-flex"
    >
    </signature-pad>
    <span v-else
      ><i class="las la-signature fs-5x" aria-hidden="true"></i
    ></span>
    <!-- <button @click="saveSignature">Save signature</button> -->
  </div>
</template>

<script>
import { ref, useAttrs, toRef, computed } from "vue";
import SignaturePad from "vue3-signature-pad";
export default {
  name: "Signature",
  components: {
    SignaturePad,
  },
  props: {
    isPreview: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const propsIsPreview = toRef(props, "isPreview");
    const signatureDataURL = ref(null);
    const signatureFile = ref(null);
    const signaturePad = ref(null);
    const attrs = useAttrs();
    const dynamicAttrs = computed(() => {
      const clonedAttrs = { ...attrs };
      // Type assertion for style attributes
      const styleAttrs = clonedAttrs.style;

      // Check if attrs.style.defaultBorder is "true !important"
      if (styleAttrs && styleAttrs.defaultBorder === "true !important") {
        styleAttrs.borderColor = "";
        styleAttrs.borderWidth = "";
        styleAttrs.borderStyle = "";
        styleAttrs.padding = "";
        styleAttrs.margin = "";
        clonedAttrs.borderColor = "";
        clonedAttrs.borderWidth = "";
        clonedAttrs.borderStyle = "";
        clonedAttrs.padding = "";
        clonedAttrs.margin = "";
      }

      return clonedAttrs;
    });
    const style = computed(() => {
      return !propsIsPreview.value ? "pointer-events: none" : "";
    });
    const getSignaturePad = () => {
      if (!signaturePad.value) {
        throw new Error("No signature pad ref could be found");
      }
      return signaturePad.value;
    };

    const clearSignature = () => {
      getSignaturePad().clearSignature();
    };

    const saveSignature = () => {
      const signature = getSignaturePad().saveSignature();
      return signature;
    };

    const onInput = (value) => {
      console.log("calling on input", value);
      if (!value) {
        signatureDataURL.value = null;
        signatureFile.value = null;
      } else if (value instanceof File) {
        signatureDataURL.value = null;
        signatureFile.value = value;
      } else {
        signatureDataURL.value = value;
        signatureFile.value = null;
      }
    };
    return {
      // state
      signaturePad,
      signatureDataURL,
      signatureFile,
      // methods
      clearSignature,
      saveSignature,
      onInput,
      attrs,
      style,
      propsIsPreview,
      dynamicAttrs,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
